import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("thead", { class: "bg-primary" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      class: "text-left text-white font-weight-bold",
      width: "10%"
    }, " Data Vencimento "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "text-left text-white font-weight-bold",
      width: "40%"
    }, " Data Quitação "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "text-left text-white font-weight-bold",
      width: "25%"
    }, " Quitado "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "text-left text-white font-weight-bold",
      width: "25%"
    }, " Ações ")
  ])
], -1)
const _hoisted_3 = { hidden: "" }
const _hoisted_4 = { class: "text-right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_BuscarUsuario = _resolveComponent("BuscarUsuario")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_file_input = _resolveComponent("v-file-input")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_table = _resolveComponent("v-table")!

  return (_openBlock(), _createBlock(_component_v_container, {
    "fill-height": "",
    fluid: "",
    style: {"height":"100vh"}
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, {
        class: "bg-surface px-2 py-2",
        density: "compact"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_title, { class: "bg-primary" }, {
            default: _withCtx(() => [
              _createTextVNode(" Cobranças ")
            ]),
            _: 1
          }),
          _createVNode(_component_v_form, {
            ref: "form",
            modelValue: _ctx.valid,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.valid) = $event)),
            "validate-on": "blur",
            onSubmit: _withModifiers(_ctx.onConsulta, ["prevent"])
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_container, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_row, { dense: true }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, {
                        cols: "12",
                        sm: "4",
                        md: "4"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_text_field, {
                            type: "number",
                            id: "idUsuario",
                            density: "compact",
                            autofocus: "",
                            modelValue: _ctx.usuarioSelecionado.idSistema,
                            "onUpdate:modelValue": [
                              _cache[0] || (_cache[0] = ($event: any) => ((_ctx.usuarioSelecionado.idSistema) = $event)),
                              _cache[1] || (_cache[1] = ($event: any) => {_ctx.debounce(() => { _ctx.usuarioFilterSerie($event); }, 500)})
                            ],
                            rules: [_ctx.requerid],
                            label: "Código",
                            required: ""
                          }, null, 8, ["modelValue", "rules"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, {
                        cols: "12",
                        sm: "6",
                        md: "6"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_text_field, {
                            id: "nome",
                            density: "compact",
                            readonly: "",
                            modelValue: _ctx.usuarioSelecionado.nome,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.usuarioSelecionado.nome) = $event))
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, {
                        cols: "12",
                        sm: "2",
                        md: "2"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_btn, {
                            color: "primary",
                            size: "small",
                            type: "button",
                            variant: "outlined",
                            class: "mt-4 w-100",
                            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.abrirBusca()))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Buscar ")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_card_actions, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_row, {
                    justify: "space-between",
                    class: "text-center"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_btn, {
                            color: "primary",
                            size: "large",
                            type: "submit",
                            variant: "outlined",
                            class: "mt-4 w-100"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Carregar Cobranças ")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_btn, {
                            color: "warning",
                            size: "large",
                            type: "button",
                            variant: "outlined",
                            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.hasHistory() ? _ctx.$router.go(-1) : _ctx.$router.push('/'))),
                            class: "mt-4 w-100"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Cancelar ")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue", "onSubmit"])
        ]),
        _: 1
      }),
      _createVNode(_component_v_dialog, {
        modelValue: _ctx.dialog,
        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.dialog) = $event)),
        persistent: "",
        width: "80%"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card, { height: "80vh" }, {
            default: _withCtx(() => [
              _createVNode(_component_BuscarUsuario, {
                onAoSelecionarUsuario: _cache[6] || (_cache[6] = ($event: any) => (_ctx.selecionarUsuario($event)))
              }),
              _createVNode(_component_v_card_actions, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    color: "primary",
                    block: "",
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.dialog = false))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Voltar")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_v_dialog, {
        modelValue: _ctx.dialogLiquidacao,
        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.dialogLiquidacao) = $event)),
        persistent: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_form, {
            ref: "formLiquidar",
            modelValue: _ctx.validDialogLiquidacao,
            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.validDialogLiquidacao) = $event)),
            "validate-on": "blur",
            onSubmit: _withModifiers(_ctx.efetuarLiquidacao, ["prevent"])
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card_title, { class: "bg-primary" }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Liquidar Cobrança ")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_container, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_row, { dense: true }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, {
                            cols: "12",
                            sm: "4",
                            md: "4"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_text_field, {
                                type: "date",
                                modelValue: _ctx.dataVencimentoLiquidacao,
                                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.dataVencimentoLiquidacao) = $event)),
                                label: "Data Vencimento",
                                readonly: ""
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, {
                            cols: "12",
                            sm: "4",
                            md: "4"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_text_field, {
                                type: "date",
                                modelValue: _ctx.dataLiquidacao,
                                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.dataLiquidacao) = $event)),
                                label: "Data Pagamento",
                                rules: [_ctx.requerid],
                                required: ""
                              }, null, 8, ["modelValue", "rules"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_card_actions, { class: "center" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_spacer),
                      _createVNode(_component_v_btn, {
                        type: "submit",
                        color: "primary"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Salvar")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_spacer),
                      _createVNode(_component_v_btn, {
                        type: "button",
                        color: "primary",
                        onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.dialogLiquidacao = false))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Voltar")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_spacer)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue", "onSubmit"])
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _hoisted_1,
      ((_ctx.mostrarCobrancas))
        ? (_openBlock(), _createBlock(_component_v_card, {
            key: 0,
            class: "bg-surface px-2 py-2 elevation-10",
            density: "compact"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_title, { class: "bg-primary" }, {
                default: _withCtx(() => [
                  _createTextVNode(" Lista de Cobranças ")
                ]),
                _: 1
              }),
              _createVNode(_component_v_form, {
                ref: "formBoleto",
                modelValue: _ctx.validCob,
                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.validCob) = $event)),
                "validate-on": "blur",
                onSubmit: _withModifiers(_ctx.adicionaBoleto, ["prevent"])
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_container, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_row, { dense: true }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, {
                            cols: "12",
                            sm: "4",
                            md: "4"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_text_field, {
                                type: "date",
                                modelValue: _ctx.dataVencimento,
                                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.dataVencimento) = $event)),
                                label: "Data Vencimento",
                                rules: [_ctx.requerid],
                                required: ""
                              }, null, 8, ["modelValue", "rules"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, {
                            cols: "12",
                            sm: "6",
                            md: "6"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_file_input, {
                                accept: "application/pdf",
                                label: "Arquivo",
                                modelValue: _ctx.arquivo,
                                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.arquivo) = $event)),
                                rules: [_ctx.requerid],
                                required: ""
                              }, null, 8, ["modelValue", "rules"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, {
                            cols: "12",
                            sm: "2",
                            md: "2"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_btn, {
                                type: "submit",
                                color: "primary",
                                size: "small",
                                variant: "outlined",
                                class: "mt-4 w-100"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(" Adicionar ")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue", "onSubmit"]),
              _createVNode(_component_v_table, {
                density: "compact",
                class: "elevation-1"
              }, {
                default: _withCtx(() => [
                  _hoisted_2,
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cobrancas, (item, i) => {
                      return (_openBlock(), _createElementBlock("tr", { key: i }, [
                        _createElementVNode("td", _hoisted_3, _toDisplayString(i), 1),
                        _createElementVNode("td", null, _toDisplayString(new Date(item.vencimento).toLocaleDateString()), 1),
                        _createElementVNode("td", null, _toDisplayString(item.dataQuitacao ? new Date(item.dataQuitacao).toLocaleDateString() : ''), 1),
                        _createElementVNode("td", null, _toDisplayString(item.quitado ? 'Pago' : 'Em Aberto'), 1),
                        _createElementVNode("td", _hoisted_4, [
                          _createVNode(_component_v_icon, {
                            size: "large",
                            icon: "mdi-wallet-travel",
                            title: "Mudar Status",
                            color: "green",
                            onClick: ($event: any) => (_ctx.liquidar(item.vencimento))
                          }, null, 8, ["onClick"]),
                          _createVNode(_component_v_icon, {
                            size: "large",
                            icon: "mdi-delete",
                            title: "Remover",
                            color: "red",
                            onClick: ($event: any) => (_ctx.removerCobranca(item.vencimento))
                          }, null, 8, ["onClick"]),
                          _createVNode(_component_v_icon, {
                            size: "large",
                            icon: "mdi-download",
                            title: "Download",
                            onClick: ($event: any) => (_ctx.download(item.vencimento))
                          }, null, 8, ["onClick"])
                        ])
                      ]))
                    }), 128))
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}